<template>
  <div class="knowledge">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="handleBack"
        >返回</el-button
      >
      <b>知识考核</b>
      <div class="btn type_btn">
        <el-select v-model="dataType" placeholder="请选择" size="mini">
          <el-option label="班级得分" :value="0"> </el-option>
          <el-option label="个人得分" :value="1"> </el-option>
        </el-select>
      </div>
      <div class="btn chapter_btn">
        <el-cascader
          v-model="classChapterId"
          @change="handleChange"
          :options="chapters"
          :props="{
            label: 'title',
            value: 'classChapterId',
            emitPath: false,
          }"
          :show-all-levels="false"
          size="mini"
          placeholder="请选择章节"
        ></el-cascader>
        <!-- <el-select
          v-model="classChapterId"
          placeholder="请选择章节"
          size="mini"
          @change="handleChange"
        >
          <el-option-group
            v-for="group in chapters"
            :key="group.classChapterId"
            :label="group.title"
          >
            <el-option
              v-for="item in group.children"
              :key="item.classChapterId"
              :label="item.title"
              :value="item.classChapterId"
            >
            </el-option>
          </el-option-group>
        </el-select> -->
      </div>
      <div
        class="btn export_btn"
        v-show="!$route.query.userId"
        @click="onExport"
      >
        导出数据 <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="main" v-if="dataType == 0">
      <div class="box_title">客观题正确率</div>
      <div class="histogram">
        <div
          class="one"
          :class="{ active: item.questionId == currentQuestion.questionId }"
          v-for="item in list"
          :key="item.questionId"
          @click="currentQuestion = item"
        >
          <div class="bars">
            <div
              class="bar right"
              :style="{
                height: (item.rightCount / item.totalCount) * 100 + '%',
              }"
            >
              <span>{{
                parseInt((item.rightCount / item.totalCount) * 100) + "%"
              }}</span>
            </div>
            <!-- <div
              class="bar wrong"
              :style="{
                height:
                  (item.errorCount /
                    (item.rightCount + item.errorCount + item.notDoneCount)) *
                    100 +
                  '%',
              }"
            >
              <span>{{ item.errorCount }}</span>
            </div>
            <div
              class="bar not"
              :style="{
                height:
                  (item.notDoneCount /
                    (item.rightCount + item.errorCount + item.notDoneCount)) *
                    100 +
                  '%',
              }"
            >
              <span>{{ item.notDoneCount }}</span>
            </div> -->
          </div>
          <p class="num">{{ item.num }}</p>
          <div class="tips">
            <p>正确：{{ item.rightCount }}</p>
            <p>错误：{{ item.errorCount }}</p>
            <p>未做：{{ item.notDoneCount }}</p>
          </div>
        </div>
        <!-- <ve-histogram
          height="180px"
          :data="chartData"
          :settings="chartSet"
          :extend="chartExtend"
          :events="chartEvents"
        ></ve-histogram> -->
      </div>
      <div class="question_box" v-if="currentQuestion">
        <p class="stem">
          <span>{{ currentQuestion.num }}：</span>
          <span>{{ currentQuestion.question }}</span>
        </p>
        <p class="options">
          <span v-for="item in currentQuestion.optionList" :key="item.tag">
            {{ item.tag }}、{{ item.option }}
          </span>
        </p>
        <p class="info">
          <span>正确答案：{{ currentQuestion.answerList.join(" ") }}，</span>
          <span>正确率：{{ correctRate }}，</span>
          <span
            >正确人数：<span
              class="count"
              style="color: #6be015"
              @click="goDetail('right')"
              >{{ currentQuestion.rightCount }}</span
            >，</span
          >
          <span
            >错误人数：<span
              class="count"
              style="color: #ff3f3f"
              @click="goDetail('error')"
              >{{ currentQuestion.errorCount }}</span
            >，</span
          >
          <span
            >未做人数：<span
              class="count"
              style="color: #969696"
              @click="goDetail('notDone')"
              >{{ currentQuestion.notDoneCount }}</span
            ></span
          >
        </p>
        <!-- <div class="legend">
          <div class="one correct"><span></span>正确</div>
          <div class="one wrong"><span></span>错误</div>
          <div class="one notdo"><span></span>未做</div>
        </div> -->
      </div>

      <div class="score_row">
        <div
          class="score_box"
          v-for="item in scoreList"
          :key="item.id"
          v-show="item.show"
        >
          <p class="score_title">{{ item.title }}</p>
          <div class="circle_box">
            <el-progress
              type="circle"
              :percentage="item.score"
              stroke-linecap="square"
              :color="item.color"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
      </div>
    </div>
    <knowledgePersonalList
      v-else
      ref="PList"
      :classChapterId="classChapterId"
    />
  </div>
</template>

<script>
import { chapterList } from "@/api/chapter";
import { zsStatistics, typeAvg } from "@/api/evaluation";
import { handleTree } from "@/utils";

import knowledgePersonalList from "./knowledgePersonalList.vue";
export default {
  components: {
    knowledgePersonalList,
  },
  data() {
    // let vm = this;
    // vm.chartEvents = {
    //   click: function (e) {
    //     vm.currentIndex = e.dataIndex;
    //   },
    // };
    return {
      dataType: 0,
      classChapterId: null,
      chapters: [],
      list: [],
      currentQuestion: null,
      // chartData: {
      //   columns: ["num", "rightCount", "errorCount", "notDoneCount"],
      //   rows: [],
      // },
      // chartExtend: {
      //   grid: {
      //     height: 100,
      //   },
      //   legend: {
      //     show: false,
      //   },
      //   yAxis: { show: false },
      //   xAxis: {
      //     axisLabel: {
      //       color: "rgba(101,198,231,0.5)",
      //     },
      //   },
      //   color: ["#6be015", "#ff3f3f", "#969696"],
      //   series: {
      //     barWidth: 25,
      //     label: {
      //       color: "#1de0fe",
      //       show: true,
      //       position: "top",
      //     },
      //   },
      // },
      // chartSet: {
      //   labelMap: {
      //     num: "题数",
      //     rightCount: "正确",
      //     errorCount: "错误",
      //     notDoneCount: "未做",
      //   },
      // },
      currentIndex: 0,
      scoreList: [
        {
          id: 1,
          title: "单选题平均分",
          score: 0,
          color: "#aae476",
          show: false,
        },
        {
          id: 2,
          title: "多选题平均分",
          score: 0,
          color: "#e1a82c",
          show: false,
        },
        {
          id: 3,
          title: "判断题平均分",
          score: 0,
          color: "#5487c8",
          show: false,
        },
      ],
    };
  },
  created() {
    this.getChapterList();
  },
  computed: {
    // currentQuestion() {
    //   return this.chartData.rows[this.currentIndex];
    // },
    correctRate() {
      return (
        parseInt((this.currentQuestion.rightCount / this.currentQuestion.totalCount) * 100) +
        "%"
      );
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          let chapters = handleTree(res.data, "chapterId");

          chapters.forEach((item) => {
            if (item.children) {
              // 二级目录
              let secondArr = item.children;
              secondArr.forEach((s) => {
                if (s.children) {
                  // 三级目录为底层
                  let thirdArr = s.children;
                  let flag = thirdArr.every((t) => !t.complete);
                  if (flag) {
                    // 三级目录里全部未生成成绩
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  } else {
                    // 三级目录筛选
                    thirdArr.forEach((t) => {
                      if (!t.complete) {
                        thirdArr = thirdArr.filter(
                          (n) => n.chapterId != t.chapterId
                        );
                      }
                    });
                  }
                } else {
                  // 二级目录为底层
                  if (!s.complete) {
                    secondArr = secondArr.filter(
                      (n) => n.chapterId != s.chapterId
                    );
                  }
                }
              });
              // 一级目录的children赋值
              if (secondArr.length > 0) {
                item.children = secondArr;
              } else {
                delete item.children;
              }
            }
          });
          // 筛选掉一级目录中无children的，生成最终目录
          this.chapters = chapters.filter((item) => item.children);
          if (this.chapters[0].children[0].children) {
            this.classChapterId =
              this.chapters[0].children[0].children[0].classChapterId;
          } else {
            this.classChapterId = this.chapters[0].children[0].classChapterId;
          }
          this.getStatistics();
          this.getAvg();
        } else {
          console.log(res.msg);
        }
      });
    },
    // 班级统计
    getStatistics() {
      this.$loading.show();
      zsStatistics({
        classId: this.$route.query.id,
        classChapterId: this.classChapterId,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          res.data.forEach((item, idx) => {
            item.num = `第${idx + 1}题`;
          });
          this.list = res.data;
          this.currentQuestion = res.data[0];
          // this.chartData.rows = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 题型平均分
    getAvg() {
      typeAvg({
        classId: this.$route.query.id,
        classChapterId: this.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.scoreList[0].score = Number(
              (res.data.radioAvg || 0).toFixed(1)
            );
            this.scoreList[1].score = Number(
              (res.data.checkboxAvg || 0).toFixed(1)
            );
            this.scoreList[2].score = Number(
              (res.data.booleanAvg || 0).toFixed(1)
            );
            this.scoreList[0].show = !!res.data.radioAvg;
            this.scoreList[1].show = !!res.data.checkboxAvg;
            this.scoreList[2].show = !!res.data.booleanAvg;
          } else {
            this.scoreList[0].score = 0;
            this.scoreList[1].score = 0;
            this.scoreList[2].score = 0;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChange(e) {
      if (this.dataType == 0) {
        this.getStatistics();
        this.getAvg();
      } else {
        if (this.$refs.PList.checkUserId) {
          this.$refs.PList.$refs.PInfo.getQuestionInfo(e);
          this.$refs.PList.$refs.PInfo.currentQuestion = null;
        } else {
          this.$refs.PList.getList(e);
        }
      }
    },
    format(percentage) {
      return percentage + "";
    },
    goDetail(type) {
      this.$router.push({
        path: "/classCourse/evaluation/knowledge/situation",
        query: {
          ...this.$route.query,
          type,
          questionId: this.currentQuestion.questionId,
        },
      });
    },
    handleBack() {
      if (this.dataType == 1 && this.$refs.PList.checkUserId) {
        this.$refs.PList.checkUserId = null;
        this.$router.replace({
          path: this.$route.path,
          query: {
            id: this.$route.query.id,
            courseId: this.$route.query.courseId,
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    // 导出
    onExport() {
      let token = localStorage.getItem("token");
      if (this.dataType == 0) {
        window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/zs/${this.$route.query.id}/export?classChapterId=${this.classChapterId}&Authorization=${token}`
        );
      } else {
        window.open(
          `${process.env.VUE_APP_API_DOMAIN}/app/teacher/statistics/zs/${this.$route.query.id}/scoreAvg/export?classChapterId=${this.classChapterId}&Authorization=${token}`
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.knowledge {
  height: 748px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      font-size: 30px;
      letter-spacing: 5px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
      &.type_btn {
        left: 0;
      }
      &.chapter_btn {
        left: 126px;
        ::v-deep .el-select,
        ::v-deep .el-cascader {
          .el-input__inner {
            padding-left: 15px;
          }
          .el-input__suffix {
            right: 6px;
          }
        }
      }
      ::v-deep .el-select,
      ::v-deep .el-cascader {
        .el-input__inner {
          padding-left: 20px;
          font-size: 14px;
          color: #fff;
          background-color: transparent;
          border: none;
        }
        .el-input__suffix {
          right: 10px;
          .el-select__caret {
            color: #fff;
          }
        }
      }
    }
  }
  .main {
    margin: 20px 2px 0;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .histogram {
      padding: 40px 0 15px;
      margin: 10px;
      box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
      text-align: left;
      white-space: nowrap;
      overflow-x: auto;
      &::-webkit-scrollbar {
        height: 6px;
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        background-color: #1ae0fe;
      }

      .one {
        position: relative;
        display: inline-block;
        margin: 0 20px;
        height: 130px;
        vertical-align: bottom;
        text-align: center;
        color: #fff;
        cursor: pointer;
        .bars {
          width: 38px;
          height: 100%;
          .bar {
            position: absolute;
            bottom: 20px;
            display: inline-block;
            margin: 0 6.5px;
            width: 25px;
            vertical-align: bottom;
            span {
              position: absolute;
              top: -20px;
              left: 50%;
              transform: translateX(-50%);
              color: #1de0fe;
            }
            &.right {
              left: 0;
              background-color: #6be015;
            }
            &.wrong {
              left: 50%;
              transform: translateX(-50%);
              background-color: #ff3f3f;
            }
            &.not {
              right: 0;
              background-color: #969696;
            }
          }
        }
        .num {
          margin-top: -15px;
          color: rgba(101, 198, 231, 0.5);
          font-size: 12px;
        }
        &.active {
          .num {
            color: #fff;
          }
        }
        &:hover {
          .tips {
            opacity: 1;
            visibility: visible;
          }
        }
        .tips {
          position: absolute;
          top: -40px;
          left: 20px;
          padding: 15px;
          border-radius: 3px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.5);
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          z-index: 999;
        }
      }
    }
    .question_box {
      position: relative;
      padding: 10px;
      text-align: left;
      color: #fff;
      .stem {
        font-weight: bold;
      }
      .options {
        margin-top: 10px;
        span {
          margin-right: 10px;
        }
      }
      .info {
        margin-top: 10px;
        .count {
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
      }

      .legend {
        position: absolute;
        right: 0;
        bottom: 10px;
        .one {
          display: inline-block;
          margin-right: 10px;
          font-size: 14px;
          span {
            display: inline-block;
            margin-right: 10px;
            width: 30px;
            height: 15px;
            vertical-align: middle;
          }
          &.correct {
            color: #6be015;
            span {
              background-color: #6be015;
            }
          }
          &.wrong {
            color: #ff3f3f;
            span {
              background-color: #ff3f3f;
            }
          }
          &.notdo {
            color: #969696;
            span {
              background-color: #969696;
            }
          }
        }
      }
    }

    .score_row {
      margin: 15px 10px 0;
      text-align: left;
      .score_box {
        display: inline-block;
        width: 280px;
        &:not(:last-child) {
          margin-right: 26px;
        }
        &:first-child {
          ::v-deep .el-progress__text,
          .text {
            color: #aae476;
          }
        }
        &:nth-child(2) {
          ::v-deep .el-progress__text,
          .text {
            color: #e1a82c;
          }
        }
        &:nth-child(3) {
          ::v-deep .el-progress__text,
          .text {
            color: #5487c8;
          }
        }
        .score_title {
          padding: 0 10px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #1de0fe;
          text-align: center;
          background-color: rgba(49, 70, 125, 0.1);
          // border: solid 1px rgba(4, 20, 40, 0.1);
          box-shadow: #1de0fe 0px 0px 5px inset;
        }
        .circle_box {
          position: relative;
          padding-top: 40px;
          height: 190px;
          text-align: center;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          ::v-deep .el-progress__text {
            // padding-right: 10px;
            font-size: 30px !important;
          }
          .text {
            position: absolute;
            top: 46%;
            right: 39%;
          }
        }
      }
    }
  }
}
</style>